import React from "react";
import { Badge, Button, ButtonProps } from "@tvg/design-system";
import { formatCurrencyTotal } from "../MyBetsCard/helpers";
import { CURRENCY_THRESHOLD } from "../MyBetsCard/constants";
import { Container, BadgeContainer } from "./styled-components";

interface ActiveBetsButtonProps {
  totalGambledCount: number;
  totalGambledAmount?: number;
  iconPosition?: ButtonProps["iconPosition"];
  onClick: () => void;
}

const ActiveBetsButton = ({
  totalGambledCount,
  totalGambledAmount,
  iconPosition = "start",
  onClick
}: ActiveBetsButtonProps) => (
  <Container data-qa-label="active-bets-container">
    <BadgeContainer position={iconPosition}>
      <Badge.Counter
        variant="secondary"
        counter={totalGambledCount}
        counterLimit={99}
        qaLabel="active-bets-badge"
      />
    </BadgeContainer>
    <Button
      qaLabel="active-bets-button"
      variant="tertiary"
      onPress={onClick}
      icon="bets"
      iconPosition={iconPosition}
      px={4}
      size="m"
    >
      {totalGambledAmount
        ? `${formatCurrencyTotal(
            totalGambledAmount,
            CURRENCY_THRESHOLD
          )} Staked`
        : "Bets"}
    </Button>
  </Container>
);

export default ActiveBetsButton;
